// extracted by mini-css-extract-plugin
module.exports = {"container":"featuredTournamentPage__container___2X0Ji","loader-block":"featuredTournamentPage__loader-block___2M3v8"};